import React, { PropTypes } from 'react';

import { AccountsCard, Message } from '../../';
import CreateAccountForm from './createAccountForm/CreateAccountForm';


const propTypes = {
  sent: PropTypes.bool,
  message: PropTypes.string.isRequired,
  callToAction: PropTypes.string.isRequired,
  callToActionLink: PropTypes.string.isRequired,
};

const CreateAccountCard = props => (
  <AccountsCard {...props}>
    {
      props.sent
      ? (
        <Message
          message={props.message}
          callToAction={props.callToAction}
          callToActionLink={props.callToActionLink}
        />
      )
      : <CreateAccountForm {...props} />
    }
  </AccountsCard>
);

CreateAccountCard.propTypes = propTypes;
export default CreateAccountCard;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/createAccountCard/CreateAccountCard.js
 **/